// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"6080cdb8","469":"6080cdb8"}[chunkId] + ".chunk.css";
};